import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CreateShareFromAssetsMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  assetIds: Array<Types.Scalars['ID']['input']>;
  colorTheme?: Types.InputMaybe<Types.ColorThemeEnum>;
  expiration?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  generatePassphrase?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  downloadingEnabled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  shareRestrictedAssets?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type CreateShareFromAssetsMutation = { __typename?: 'Mutation', createShareFromAssets?: { __typename?: 'CreateShareFromAssetsPayload', share?: { __typename?: 'AdHocAssetsShare', id: string, colorTheme: Types.ColorThemeEnum, enabled: boolean, expiration?: string | null, expiresIn?: number | null, name: string, passphrase?: string | null, url?: string | null, isGeneratedPassphrase?: boolean | null } | { __typename?: 'CollectionShare', id: string, colorTheme: Types.ColorThemeEnum, enabled: boolean, expiration?: string | null, expiresIn?: number | null, name: string, passphrase?: string | null, url?: string | null, isGeneratedPassphrase?: boolean | null } | null, metadata?: { __typename?: 'CreateShareFromAssetsMetadata', passphraseGenerated: boolean } | null } | null };


export const CreateShareFromAssets = /*#__PURE__*/ gql`
    mutation CreateShareFromAssets($projectId: ID!, $assetIds: [ID!]!, $colorTheme: ColorThemeEnum, $expiration: DateTime, $generatePassphrase: Boolean, $downloadingEnabled: Boolean, $shareRestrictedAssets: Boolean) {
  createShareFromAssets(
    input: {assetIds: $assetIds, projectId: $projectId, settings: {colorTheme: $colorTheme, expiration: $expiration, generatePassphrase: $generatePassphrase, downloadingEnabled: $downloadingEnabled}, shareRestrictedAssets: $shareRestrictedAssets}
  ) {
    share {
      id
      colorTheme
      enabled
      expiration
      expiresIn
      name
      passphrase
      url
      isGeneratedPassphrase @client
    }
    metadata {
      passphraseGenerated
    }
  }
}
    ` as unknown as DocumentNode<CreateShareFromAssetsMutation, CreateShareFromAssetsMutationVariables>;

          

          export const useCreateShareFromAssetsMutation = (options?:MutationHookOptions<CreateShareFromAssetsMutation, CreateShareFromAssetsMutationVariables>) => useMutation(CreateShareFromAssets, options);
          

          export type CreateShareFromAssetsMutationOptions = MutationHookOptions<CreateShareFromAssetsMutation, CreateShareFromAssetsMutationVariables>;

          

          export type CreateShareFromAssetsMutationResult = ReturnType<typeof useCreateShareFromAssetsMutation>[1];

          
